import React, { useState, useMemo } from "react";
import {
    Box,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TextField,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Typography,
    Paper
} from "@mui/material";

const BulkVerificationTable = ({ data }) => {
    const [page, setPage] = useState(0);
    const rowsPerPage = 5;

    const [search, setSearch] = useState("");
    const [docTypeFilter, setDocTypeFilter] = useState("");

    const handleSearchChange = (e) => setSearch(e.target.value);
    const handleDocTypeChange = (e) => setDocTypeFilter(e.target.value);
    const handlePageChange = (_, newPage) => setPage(newPage);

    const filteredData = useMemo(() => {
        return data.filter((row) => {
            const matchesSearch =
                row.vendor_mail?.toLowerCase().includes(search.toLowerCase()) ||
                row.vendor_code?.toLowerCase().includes(search.toLowerCase());
            const matchesType = docTypeFilter ? row.document_type === docTypeFilter : true;
            return matchesSearch && matchesType;
        });
    }, [data, search, docTypeFilter]);

    const paginatedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <Paper sx={{ mt: 4, p: 2, fontSize: '14px' }}>
            {/* Filters */}
            <Box sx={{ display: "flex", gap: 2, mb: 2, justifyContent: 'space-between' }}>
                <TextField
                    label="Search (Email or Vendor Code)"
                    variant="outlined"
                    value={search}
                    onChange={handleSearchChange}
                    sx={{ width: '20rem', fontSize: '14px' }}
                    InputProps={{ sx: { fontSize: '14px' } }}
                    InputLabelProps={{ sx: { fontSize: '14px' } }}
                />
                <FormControl sx={{ width: '20rem' }}>
                    <InputLabel sx={{ fontSize: '14px' }}>Document Type</InputLabel>
                    <Select
                        value={docTypeFilter}
                        onChange={handleDocTypeChange}
                        label="Document Type"
                        sx={{ fontSize: '14px' }}
                    >
                        <MenuItem value="pan" sx={{ fontSize: '14px' }}>PAN</MenuItem>
                        <MenuItem value="gst" sx={{ fontSize: '14px' }}>GST</MenuItem>
                        <MenuItem value="bank" sx={{ fontSize: '14px' }}>Bank</MenuItem>
                        <MenuItem value="msme" sx={{ fontSize: '14px' }}>MSME</MenuItem>
                        <MenuItem value="mca" sx={{ fontSize: '14px' }}>MCA</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            {/* Table */}
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontSize: '14px' }}>#</TableCell>
                        <TableCell sx={{ fontSize: '14px' }}>Vendor Code</TableCell>
                        <TableCell sx={{ fontSize: '14px' }}>Email</TableCell>
                        <TableCell sx={{ fontSize: '14px' }}>Doc Type</TableCell>
                        <TableCell sx={{ fontSize: '14px' }}>Status</TableCell>
                        <TableCell sx={{ fontSize: '14px' }}>Verified Name</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedData.map((row, index) => (
                        <TableRow key={row.token}>
                            <TableCell sx={{ fontSize: '13px' }}>{page * rowsPerPage + index + 1}</TableCell>
                            <TableCell sx={{ fontSize: '13px' }}>{row.vendor_code || "-"}</TableCell>
                            <TableCell sx={{ fontSize: '13px' }}>{row.vendor_mail}</TableCell>
                            <TableCell sx={{ fontSize: '13px' }}>{row.document_type?.toUpperCase()}</TableCell>
                            <TableCell sx={{ fontSize: '13px' }}>{row.overall_status}</TableCell>
                            <TableCell sx={{ fontSize: '13px' }}>
                                {row.pan_verified_name ||
                                    row.gst_trade_name ||
                                    row.msme_enterprise_name ||
                                    row.bank_holder_name ||
                                    "-"}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[rowsPerPage]}
                sx={{ fontSize: '14px' }}
            />
        </Paper>
    );
};

export default BulkVerificationTable;
